import { useCallback, useContext, useEffect } from 'react';
import core, { App } from '@gin-betting/core';

import { useAppliedFilters } from 'hooks';
import promo from 'modules/promo';
import { OverlayType } from '../../../constants';
import { MobileFiltersCtx } from '../MobileFiltersCtx';

const {
    services: { getHistory },
} = core;

interface Output {
    openOverlay: VoidFn;
    isActive: boolean;
    count: number;
}

const {
    hooks: { useFeaturedConfigs },
} = promo;

function useFeaturedTournamentsHeading(): Output {
    const { featuredConfigs } = useFeaturedConfigs();
    const { sportId } = useAppliedFilters();
    const { currentOverlay, setOverlay } = useContext(MobileFiltersCtx);

    const isSportIdExist = !!sportId;

    useEffect(() => {
        if (!isSportIdExist) return;

        setOverlay(OverlayType.NONE);
    }, [isSportIdExist, setOverlay]);

    const openOverlay = useCallback(() => {
        setOverlay(OverlayType.FEATURED_TOURNAMENTS_LIST);

        const history = getHistory();
        history.replace(App.Routes.UPCOMING_LIST);
    }, [setOverlay]);

    return {
        openOverlay,
        count: featuredConfigs.count(),
        isActive: currentOverlay === OverlayType.FEATURED_TOURNAMENTS_LIST,
    };
}

export default useFeaturedTournamentsHeading;
